var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLocation = function SvgIconLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.397,
    height: 15.195
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#244d5a",
    d: "M5.7 8.427a2.849 2.849 0 1 0-2.85-2.849A2.85 2.85 0 0 0 5.7 8.427m0-5.227a2.374 2.374 0 1 1-2.375 2.378A2.376 2.376 0 0 1 5.7 3.2m0-3.2A5.684 5.684 0 0 0 0 5.7c0 3.324 2.85 6.724 4.927 9.114a1.16 1.16 0 0 0 .753.382h.037a1.16 1.16 0 0 0 .753-.382C8.548 12.423 11.4 9.023 11.4 5.7A5.685 5.685 0 0 0 5.7 0m.056 14.19a1 1 0 0 1-.064.047.5.5 0 0 0-.061-.063c-1.74-2-4.679-5.382-4.679-8.475a4.75 4.75 0 1 1 9.5 0c0 3.092-2.938 6.472-4.694 8.491Z"
  })));
};
export default SvgIconLocation;